import { Navigate } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import { isDevAllowed, isLead, isSupervisor } from '@/lib/dev-team'
import { DevSprintApp } from '@/components/dev/DevSprintApp'

// Halaman /dev — TERSEMBUNYI. Gate allowlist di client; API juga gated di server.
export default function Dev() {
  const { user, loading } = useAuth()
  if (loading) return null
  if (!user || !isDevAllowed(user.email)) return <Navigate to="/" replace />
  return (
    <DevSprintApp
      meEmail={user.email}
      meUsername={user.username}
      isLead={isLead(user.email)}
      isSupervisor={isSupervisor(user.email)}
    />
  )
}
